import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { PlantsEntity } from "./plants.entity";
import { PlantsController } from "./plants.controller";
import { PlantsService } from "./plants.service";


@Module({
    imports: [
        TypeOrmModule.forFeature([PlantsEntity]),
    ],
    controllers: [PlantsController],
    providers: [PlantsService, ApplicationExceptionHandler]
})
export class PlantsModule {

}